import { ComponentType, lazy, ReactNode, Suspense } from 'react';

import Loader from 'src/common/components/Loader';

interface LazyPageOptions {
  /** Suspense fallback while the route chunk loads. Public routes use `null`. */
  fallback?: ReactNode;
}

export function lazyPage<P extends object>(
  factory: () => Promise<{ default: ComponentType<P> }>,
  options?: LazyPageOptions,
) {
  const Lazy = lazy(factory);
  const fallback = options && 'fallback' in options ? options.fallback : <Loader isLoading />;

  function LazyPage(props: P) {
    return (
      <Suspense fallback={fallback}>
        <Lazy {...props} />
      </Suspense>
    );
  }

  return LazyPage;
}

export function lazyPublicPage<P extends object>(
  factory: () => Promise<{ default: ComponentType<P> }>,
) {
  return lazyPage(factory, { fallback: null });
}
